import { useState } from 'react'
import { MdArrowDropUp } from 'react-icons/md'
import { cn } from '../../libs/utils'

export function TooltipBand({ message, children, color, className }) {
	const [showTooltip, setShowTooltip] = useState(false)

	return (
		<div className='tw-relative tw-flex tw-justify-center' onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
			{children}
			{showTooltip && (
				<div className='tw-bg-gray-900 tw-backdrop-blur-sm tw-text-white tw-absolute tw-z-[40] tw-p-2 tw-rounded-md tw-shadow-md tw-top-[150%] tw-flex tw-justify-center'>
					<MdArrowDropUp className='tw-absolute tw-top-[-26px] tw-text-gray-900' size={45} />
					<div className='tw-w-[350px] tw-p-2 tw-space-y-3'>
						<p>Para definir la MEDIANA de la Banda, tienes 2 opciones:</p>
						<ul className='tw-m-0 tw-list-decimal tw-space-y-4'>
							<li>Banda MyDNA : usamos el sueldo de mercado calculado por MyDNA como punto medio</li>
							<li className=''>
								Banda Mi Empresa : En caso de que ya tengas definido y estés trabajando con una banda específica de tu organización,
								puedes registrar los niveles de banda y asociarlos a sus colaboradores en el espacio en blanco que aparece
							</li>
						</ul>
					</div>
				</div>
			)}
		</div>
	)
}
